// La imagen de un post de Instagram. Viene del CDN de Instagram: sin `referrer` (así no la
// rechaza) y con un ícono si no carga, porque esas URLs vencen —
// ADR-2026-10-29-dashboard-de-metricas-de-instagram.
//
// Va con `<img>` y no con `<CachedImg>` a propósito: la URL vence en días y el CDN de Instagram
// no promete CORS, así que no hay nada que guardar. Si lo que vino es un video (un carrusel que
// empieza con un reel, o un reel sin miniatura), se muestra su primer cuadro.

import { useState } from 'react';
import { ImageOff } from 'lucide-react';

export function MiniaturaDeInstagram({ src, className = '' }: { src: string | null; className?: string }) {
  // La falla es de UNA url: si cambia el post (el detalle reusa este componente), se vuelve a probar como imagen.
  const [falla, setFalla] = useState<{ src: string | null; paso: 'video' | 'rota' } | null>(null);
  const paso = falla && falla.src === src ? falla.paso : 'imagen';
  if (!src || paso === 'rota') {
    return (
      <span className={`grid place-items-center bg-neutral-100 text-neutral-300 ${className}`}>
        <ImageOff className="w-5 h-5" />
      </span>
    );
  }
  if (paso === 'video') {
    return (
      <video
        src={`${src}#t=0.1`}
        muted
        playsInline
        preload="metadata"
        aria-hidden="true"
        onError={() => setFalla({ src, paso: 'rota' })}
        className={`pointer-events-none bg-neutral-100 object-cover ${className}`}
      />
    );
  }
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFalla({ src, paso: 'video' })}
      className={`bg-neutral-100 object-cover ${className}`}
    />
  );
}
